import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Animate on arrival without hiding content while observers or scripts load.
export default function PageMotion() {
  const { pathname } = useLocation();
  useEffect(() => {
    const media = window.matchMedia?.('(prefers-reduced-motion: reduce)');
    if (media?.matches || !window.IntersectionObserver || !Element.prototype.animate) return;
    const main = document.querySelector('main');
    if (!main) return;
    const seen = new WeakSet();
    const animations = new Set();
    const selector = '.display-title, .journey-card, .vehicle-card, .vehicle-detail, .pkg-card, .place-card, .value-card, .about-img-wrap, .contact-cta-card, .booking-form, .map-explorer, .gallery-item, .amber-line';
    const observer = new IntersectionObserver(entries => {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) return;
        observer.unobserve(target);
        const line = target.classList.contains('amber-line');
        const frames = line
          ? [{ transform: 'scaleX(.15)', opacity: .3 }, { transform: 'scaleX(1)', opacity: 1 }]
          : [{ transform: 'translateY(22px)', opacity: .35 }, { transform: 'translateY(0)', opacity: 1 }];
        const animation = target.animate(frames, { duration: line ? 700 : 580, easing: 'cubic-bezier(.2,.75,.25,1)' });
        animations.add(animation);
        animation.onfinish = () => animations.delete(animation);
      });
    }, { threshold: .08 });
    const discover = () => main.querySelectorAll(selector).forEach(node => {
      if (!seen.has(node)) { seen.add(node); observer.observe(node); }
    });
    discover();
    const mutations = new MutationObserver(discover);
    mutations.observe(main, { childList: true, subtree: true });
    const stop = () => { observer.disconnect(); mutations.disconnect(); animations.forEach(a => a.cancel()); animations.clear(); };
    const onPreference = () => { if (media.matches) stop(); };
    media?.addEventListener('change', onPreference);
    return () => { stop(); media?.removeEventListener('change', onPreference); };
  }, [pathname]);
  return null;
}
